// extracted by mini-css-extract-plugin
module.exports = {"container":"EditableFixedNumberField_container__1g-q4"};